import { makeStyles } from "@mui/styles"

export default makeStyles(() => ({
    list: {
        margin: 0,
        padding: 0,
        paddingLeft: "1em"
    }
}))
